import React from 'react';
import PropTypes from 'prop-types';

import { Button, Spinner } from 'react-bootstrap';

import { ExportStatus } from 'lib/enums/ExportStatus';
import { FILE_EXPORT_PRESIGNED_URL, getURL } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function FileExportDownloadButton({ exportId, status }) {
  const {
    data: { data: presignedUrl } = {},
    loading,
    refetch,
  } = useGet(
    getURL(FILE_EXPORT_PRESIGNED_URL, { export_id: exportId }),
    {},
    false,
    true, // lazy - fetch only when user clicks Download
  );

  const handleDownloadClick = () => {
    if (presignedUrl) {
      window.location.href = presignedUrl;
    } else {
      refetch(response => {
        if (response?.status === 200 && response.data?.data) {
          window.location.href = response.data.data;
        }
      });
    }
  };

  if (status === ExportStatus.PROCESSING) {
    return null;
  }

  const isDone = status === ExportStatus.DONE;
  return (
    <Button variant="outline-primary" onClick={handleDownloadClick} disabled={!isDone || loading}>
      {loading ? (
        <>
          <Spinner animation="border" role="status" size="sm" className="me-2">
            <span className="sr-only">Loading...</span>
          </Spinner>
          Loading...
        </>
      ) : isDone ? (
        'Download'
      ) : (
        'Not Available'
      )}
    </Button>
  );
}

FileExportDownloadButton.propTypes = {
  exportId: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
};

export default FileExportDownloadButton;
